import React from "react";
import { Stack, Typography } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";
import { FormattedMessage } from "react-intl";

import { LottieIcon, PageContainer } from "src/shared/ui";
import { LottieIconNames } from "src/shared/config";
import { PartnersMarquee } from "src/widgets/PartnersMarquee";
import { ProductsGrid } from "src/widgets/ProductsGrid";

export const HomePage: React.FC = () => {
  return (
    <PageContainer
      mainComponent={
        <>
          <Stack
            height={1}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            zIndex={99}
          >
            <Typography
              variant="h2"
              fontWeight="bold"
              color={blueGrey[700]}
              whiteSpace="pre-wrap"
              textAlign="center"
            >
              <FormattedMessage
                id="home.bigText"
                defaultMessage="Empower your business {nl} with our AI solutions"
                values={{ nl: "\n" }}
              />
            </Typography>

            <Typography
              variant="h5"
              color={grey[900]}
              whiteSpace="pre-wrap"
              textAlign="center"
            >
              <FormattedMessage
                id="home.subText"
                defaultMessage="Get a personalized, business-ready solution {nl} in no time with
              our leading AI experts."
                values={{ nl: "\n" }}
              />
            </Typography>
          </Stack>

          <LottieIcon
            icon={LottieIconNames.CIRCULAR_GRADIENT}
            autoPlay
            loop
            style={{
              position: "absolute",
              top: 0,
              height: "calc(100% - 258px)",
              filter: "blur(10px)",
            }}
          />

          <PartnersMarquee />
        </>
      }
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="flex-start"
        spacing={4}
      >
        <Typography
          variant="h4"
          color={blueGrey[600]}
          letterSpacing={4}
          textTransform="uppercase"
        >
          <FormattedMessage
            id="global.ourProducts"
            defaultMessage="Our products"
          />
        </Typography>

        <ProductsGrid />
      </Stack>
    </PageContainer>
  );
};
